import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import '@popperjs/core/dist/umd/popper.min.js'

export { wrapRootElement } from './gatsby-ssr'

let imageMutationObserver: MutationObserver | null = null

const viewportMultiplierForEager = 1.1

const getImageArea = (img: HTMLImageElement): number => {
  const width = img.naturalWidth || img.width || img.clientWidth || 0
  const height = img.naturalHeight || img.height || img.clientHeight || 0
  return width * height
}

const shouldSkipLazyForImage = (img: HTMLImageElement): boolean => {
  if (img.dataset.critical === 'true') return true
  if (img.getAttribute('fetchpriority') === 'high') return true

  const src = (img.currentSrc || img.getAttribute('src') || '').toLowerCase()
  if (src.endsWith('.svg')) return true

  const area = getImageArea(img)
  if (area > 0 && area <= 4096) return true

  const rect = img.getBoundingClientRect()
  return rect.top < window.innerHeight * viewportMultiplierForEager
}

const optimizeImages = (): void => {
  const imageList = Array.from(
    document.querySelectorAll<HTMLImageElement>(
      'img:not([data-image-optimized="true"])',
    ),
  )

  imageList.forEach((img) => {
    const skipLazy = shouldSkipLazyForImage(img)

    if (!img.hasAttribute('loading')) {
      img.setAttribute('loading', skipLazy ? 'eager' : 'lazy')
    }

    if (!img.hasAttribute('decoding')) {
      img.setAttribute('decoding', 'async')
    }

    if (!img.hasAttribute('fetchpriority') && !skipLazy) {
      img.setAttribute('fetchpriority', 'low')
    }

    img.dataset.imageOptimized = 'true'
  })
}

const scheduleImageOptimization = (): void => {
  window.requestAnimationFrame(() => {
    optimizeImages()
  })
}

export const onInitialClientRender = (): void => {
  scheduleImageOptimization()

  if (imageMutationObserver) return

  imageMutationObserver = new MutationObserver(() => {
    scheduleImageOptimization()
  })

  imageMutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  })
}

export const onRouteUpdate = (): void => {
  scheduleImageOptimization()
}
